import { BodyText, Link } from '@farol-ds/react'

import { HELP_CENTER_URL, HELP_CENTER_URL_B2B } from '../../constants'
import { LoginCard } from '../login-card/login-card'
import styles from './email-validation-account.module.scss'

interface EmailValidationAccountProps {
  email: string
  showSupportMessage?: boolean
  isB2B?: boolean
  onCloseClick?: () => void
}

export function EmailValidationAccount({
  email,
  showSupportMessage = true,
  isB2B = false,
  onCloseClick,
}: EmailValidationAccountProps) {
  const supportUrl = isB2B ? HELP_CENTER_URL_B2B : HELP_CENTER_URL
  const header = {
    title: 'Verifique seu e-mail',
    subtitle: {
      content: (
        <>
          Enviamos um e-mail para <strong className={styles.email}>{email}</strong> com um link para
          validar a sua conta.
        </>
      ),
    },
  }

  return (
    <LoginCard header={header} onCloseClick={onCloseClick}>
      <div className={styles.content}>
        {showSupportMessage && (
          <BodyText className={styles.bodyTextSecondary}>
            Caso não tenha recebido o e-mail, verifique a caixa de spam ou entre em contato com a
            gente através do nosso{' '}
            <Link href={supportUrl} className={styles.link} target="_blank">
              Suporte ao Usuário.
            </Link>
          </BodyText>
        )}
      </div>
    </LoginCard>
  )
}
